import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HisBackendService } from 'hisng';

import { PublicationType } from '../model/publication-type';
import { PublicationTypeRelation } from '../model/publication-type-relation';

@Injectable()
export class PublicationTypeRelationService {
    constructor( private backendService: HisBackendService ) { }


    getPublicationTypesByChildId( childId: number ): Observable<PublicationType[]> {
        return this.backendService.getData( `api/v1/fs/res/publication/publicationTypes?child=${childId}` );
    }

    getPublicationTypeChildParentMap(): Observable<{[key: string]: PublicationType[]}> {
        return this.backendService.getData( 'api/v1/fs/res/publicationTypeRelationMap' );
    }

    getAllPublicationTypeRelations(): Observable<PublicationTypeRelation[]> {
        return this.backendService.getData( 'api/v1/fs/res/publicationTypeRelation' );
    }

    savePublicationTypeRelations( publicationTypeRelations: PublicationTypeRelation[] ): Observable<PublicationTypeRelation[]> {
        return this.backendService.postData( 'api/v1/fs/res/publicationTypeRelation', publicationTypeRelations );
    }
}
